import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false, className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className={`h-px w-8 ${light ? "bg-gold" : "bg-gold"}`} aria-hidden="true" />
    <span
      className={`text-[11px] md:text-xs uppercase tracking-widest2 font-medium ${
        light ? "text-gold" : "text-forest-mist"
      }`}
    >
      {children}
    </span>
  </div>
);

export const GoldButton = ({ children, onClick, variant = "solid", className = "", testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`group/btn relative inline-flex items-center justify-center px-10 py-4 text-[11px] md:text-xs uppercase tracking-widest2 font-medium transition-colors duration-500 ${
      variant === "solid"
        ? "bg-forest text-ivory hover:bg-gold hover:text-forest"
        : "border border-gold/70 text-gold hover:bg-gold hover:text-forest"
    } ${className}`}
  >
    {children}
  </button>
);
